export default "__VITE_ASSET__CDuhffPc__"